import { z } from 'zod';
import { SchemaVersionSchema } from './common.js';

export const PLUGIN_KINDS = ['connector', 'ai-provider', 'visualization', 'function'] as const;
export const PluginKindSchema = z.enum(PLUGIN_KINDS);
export type PluginKind = z.infer<typeof PluginKindSchema>;

const SEMVER =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-[0-9A-Za-z.-]+)?(?:\+[0-9A-Za-z.-]+)?$/;

/** Manifiesto que todo plugin debe declarar para ser cargado por la plataforma. */
export const PluginManifestSchema = z.object({
  schemaVersion: SchemaVersionSchema,
  /** Identificador unico en notacion de dominio inverso, por ejemplo `com.acme.snowflake`. */
  id: z.string().regex(/^[a-z0-9]+(\.[a-z0-9-]+)+$/),
  name: z.string().min(1).max(200),
  version: z.string().regex(SEMVER, 'Version semantica invalida'),
  kind: PluginKindSchema,
  description: z.string().max(2000).optional(),
  /** Modulo de entrada relativo a la raiz del plugin. */
  entry: z.string().min(1),
  /** Rango de versiones de la plataforma compatibles. */
  engines: z.object({ aibi: z.string().min(1) }),
  capabilities: z.array(z.string().min(1)).default([]),
});
export type PluginManifest = z.infer<typeof PluginManifestSchema>;
